import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06188cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-over-modal-header" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "game-over-modal-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Congratulations!", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Please check the Discord to discuss the game or to check for new content updates! ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons game-over-modal-discord" }, "discord", -1))

import Modal from "components/Modal.vue";
import { hasWon } from "data/projEntry";
import projInfo from "data/projInfo.json";
import player from "game/player";
import { formatTime } from "util/bignum";
import { loadSave, newSave } from "util/save";
import { computed, toRef } from "vue";
import Toggle from "./fields/Toggle.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { title, logo, discordName, discordLink, versionNumber, versionTitle } = projInfo;

const timePlayed = computed(() => formatTime(player.timePlayed));
const isOpen = computed(() => hasWon.value && !player.keepGoing);
const autosave = toRef(player, "autosave");

function keepGoing() {
    player.keepGoing = true;
}

function playAgain() {
    loadSave(newSave());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { "model-value": _unref(isOpen) }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(logo))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "game-over-modal-logo",
              src: _unref(logo),
              alt: _unref(title)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("h4", null, "You've beaten " + _toDisplayString(_unref(title)) + " v" + _toDisplayString(_unref(versionNumber)) + ": " + _toDisplayString(_unref(versionTitle)), 1)
        ])
      ])
    ]),
    body: _withCtx(({ shown }) => [
      shown
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, "It took you " + _toDisplayString(_unref(timePlayed)) + " to beat the game.", 1),
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                href: _unref(discordLink),
                class: "game-over-modal-discord-link"
              }, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_unref(discordName)), 1)
              ], 8, _hoisted_9)
            ]),
            _createVNode(Toggle, {
              title: "Autosave",
              modelValue: _unref(autosave),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(autosave) ? (autosave).value = $event : null))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "game-over-footer" }, [
        _createElementVNode("button", {
          onClick: keepGoing,
          class: "button"
        }, "Keep Going"),
        _createElementVNode("button", {
          onClick: playAgain,
          class: "button danger"
        }, "Play Again")
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})